import { render } from "./UploadProf.vue?vue&type=template&id=30b4d6c3&scoped=true"
import script from "./UploadProf.vue?vue&type=script&lang=js"
export * from "./UploadProf.vue?vue&type=script&lang=js"

import "./UploadProf.vue?vue&type=style&index=0&id=30b4d6c3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30b4d6c3"

export default script